import { createIcon } from 'native-base';

export const SpeakerIcon = () => {
  const CustomIcon = createIcon({
    viewBox: '0 0 256 256',
    path: [
      <g opacity="0.2">
        <path d="M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80Z" />
      </g>,
      <g>
        <path d="M224.56836,71.43066a8.00053,8.00053,0,0,0-11.31445,11.31446,63.99788,63.99788,0,0,1,0,90.50976,8.00053,8.00053,0,0,0,11.31445,11.31446,80.00148,80.00148,0,0,0,0-113.13868Z" />
        <path d="M155.51465,24.81348a7.99385,7.99385,0,0,0-8.42578.87207L77.25488,80H32A16.01833,16.01833,0,0,0,16,96v64a16.01833,16.01833,0,0,0,16,16H77.25488l69.834,54.31445A7.99958,7.99958,0,0,0,160,224V32A7.9997,7.9997,0,0,0,155.51465,24.81348ZM32,96H71.9707v64H32ZM144,207.64258,87.9707,164.06543V91.93457L144,48.35742Z" />
        <path d="M184.96973,99.7168a7.99913,7.99913,0,0,0,.001,11.31347,23.99832,23.99832,0,0,1,0,33.93946,7.99983,7.99983,0,1,0,11.3125,11.31445,39.99719,39.99719,0,0,0,0-56.56836A7.99825,7.99825,0,0,0,184.96973,99.7168Z" />
      </g>,
    ],
  });
  return <CustomIcon size={6} />;
};
